<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top navbar-expand"
    :class="{'bg-success navbar-dark': type === 'default'}"
  >

    <ul class="navbar-nav align-items-center ml-xl-auto">
      <li class="nav-item d-xl-none">
        <div
          class="pr-3 sidenav-toggler mb-3"
          :class="{active: $sidebar.showSidebar, 'sidenav-toggler-dark': type === 'default', 'sidenav-toggler-light': type === 'light'}"
          @click="toggleSidebar"
        >
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
    </ul>
     <ul class="navbar-nav align-items-center ml-auto ml-md-0">
      <base-dropdown
        menu-on-right
        class="nav-item"
        tag="li"
        title-tag="a"
        title-classes="nav-link pr-0"
      >
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <div class="user-header">
            <span class="avatar img avatar-sm rounded-circle align-middle">
              <img :src="imageSRC" alt="Image placeholder" v-if="login.IsVisitor?  login.Photograph : login.Logo" />
              <img src="../../../public/img/placeholder-user.png" alt="Image placeholder" v-else />
            </span>
            <span class="mb-0 ml-2 text-sm font-weight-bold align-middle d-none d-md-inline-block">{{$store.getters.login.Name }}</span>
          </div>
        </a>

        <template>
          <div class="dropdown-item" @click="Logout()" v-for="(user, index) in data.userDropdown" :key="index">
            <i :class="'ni ni-'+ user.icon"></i>
            <span>{{user.name}}</span>
          </div>
        </template>
      </base-dropdown>
    </ul>
  </base-nav>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";
import jsondata from "assets/json/data.json";
import {mapGetters} from "vuex";
import state from "../../store/state";

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal
  },
  props: {
    type: {
      type: String,
      default: "default", // default|light
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)"
    }
  },
  data() {
    return {
      data: jsondata,
      imageSRC:'',
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: ""
    };
  },
  computed:{
       ...mapGetters({
              login: "login",
              loading: "loading",
              userType: "type",
       }),
      routeName() {
          const { name } = this.$route;
          return this.capitalizeFirstLetter(name);
      }
  },
  watch: {
      login(){
          this.getPhotograph();
      }
  },
  mounted(){
      this.getPhotograph();
  },
  methods: {
    getPhotograph(){
        let photo = this.login.IsVisitor? this.login.Photograph : this.login.Logo;
        if(photo){
            this.imageSRC =  state.mediaURL + photo;
        }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    Logout(){

       if(this.unauthorized){
            this.$store.commit('setSessionExpired',true);
          }else{
              this.$store.commit('setSessionExpired',false);
          }
       this.$store.commit("setLogin", {
                          token: null,
                          expires_in: null,
                          loginTime: null
                      });
            if(this.$route.name != 'Login'){
                          return this.$router.push({name: 'Login'});
                      }


    }
  }
};
</script>
